import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as o}from"../../icon-registry.js";const s=o("checkout",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg">
            <rect
                width="24"
                height="24"
                rx="12"
                fill="#186AFF" />
            <path
                d="M8.81431 6H15.9572L8.81431 18.5M8.81431 6L4.88574 12.0714L8.81431 18.5M8.81431 6L15.9572 18.5H8.81431"
                stroke="white"
                stroke-width="1.07143" />
        </svg>
    `);export{s as Checkout};
